/**
 * 编辑页路由
 */
"use strict";
angular.module("editPageRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("editpage", {
        url: "/editpage?id&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
                    '<div class="view_body">' +
                    '<div ui-view="main"></div>' +
                    '</div>'
            },
            "header@editpage": {
                templateUrl: 'header/headerDetails_tpl.html',
                controller: 'webHeaderCtrl'
            },
            "main@editpage": {
                templateUrl: "./main/submissionManage/personalLibrary/editPage/editPage_tpl.html",
                controller: "editPageCtrl"
            }
        }
    });
}]);